<template>
  <div>
    <content-panel>
      <table-panel ref="tablePanel">
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight">
          <el-table-column type="index" label="编号" width="60" align="center"></el-table-column>
          <el-table-column prop="notificationEvent" label="事件通知" width="160"  align="center" ></el-table-column>
          <el-table-column prop="triggeringCondition" label="触发事件条件" align="center" ></el-table-column>
          <el-table-column prop="roleName" label="通知对象" width="120" align="center"></el-table-column>
          <el-table-column prop="msgContent" label="通知消息内容" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="60">
            <template slot-scope="scope">
              <span>{{scope.row.status | status}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateName" label="更新人" width="120" align="center"></el-table-column>
          <el-table-column prop="updatedTime" label="更新时间" width="150"  show-overflow-tooltip align="center"></el-table-column>
          <el-table-column  label="操作" width="100" class-name="action-column" align="center" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="edit(scope.row, true)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right;">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <edit-pop :visible.sync="visible" v-model="editData" @editSuccess="init"/>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import editPop from './components/editPop'
export default {
  name: "messageInform",
  mixins: [tableMixin],
  components: { editPop },
  data() {
    return {
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      loading: false,
      resizeOffset: 70,
      visible: false,
      editData: {
        id: '',
        roleCode: '',
        roleName: '',
        notificationEvent: '',
        msgContent: '',
        remark: '',
        status: '',
      }
    }
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: { }
      }
      this.$api.messageInform.queryMsgConfigList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    edit(row) {
      for(let [key,value] of Object.entries(this.editData)) {
        this.editData[key] = row[key]
      }
      this.visible = true
    },
  },
  filters: {
    status(state) {
      let map = {
        0: '停用',
        1: '启用'
      }
      return map[state]
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
      text-align: center;
      padding: 6px 0;
    }
  }
  .img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .img {
      width: 40px;
      height: 40px;
      margin: 4px 0;
      border-radius: 6px;
      cursor: pointer;
    }
    span {
      margin-left: 4px;
    }
  }
</style>